

import React, { useState } from 'react';
import EmployeeTable from '../../../component/rbacManagement/employee';
import Permissions from '../../../component/rbacManagement/permissions';
import AssignRole from '../../../component/rbacManagement/assignRole';
import { useSelector } from 'react-redux';


const tabs = ['Create Employee', 'Create/Assign Role'];

const RBACManagementBusiness = () => {
  const [activeTab, setActiveTab] = useState('Create Employee');
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;

  const renderContent = () => {
    switch (activeTab) {
      case 'Create Employee':
        return <EmployeeTable  usertype ={"business user"} storeId = {storeId}/>;
      case 'Create/Assign Role':
        return <AssignRole usertype ={"business user"} storeId = {storeId}/>;
      default:
        return null;
    }
  };

  return (
    <div className="pl-8 pr-6">
      <h2 className="text-2xl font-semibold mb-2 mt-1 ml-1">RBAC Management</h2>

      <div className='bg-[var(--primary-bg-color)] rounded-lg shadow px-2 pt-5 dark:border dark:border-[var(--table-border)]'>
        {/* Tab Header */}
        <div className="flex border-b mb-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 border-b-2 text-sm font-medium transition-all ${activeTab === tab
                  ? 'border-[#3587B8] text-[#3587B8]'
                  : 'border-transparent text-gray-500 hover:text-[#3587B8]'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default RBACManagementBusiness;
